import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import LegalLayout, { LegalSection, LegalList } from "../components/LegalLayout";

export default function Terms() {
    return (
        <>
            <Seo
                title="Terms & Conditions"
                path="/terms"
                description="ezBuildABot Terms & Conditions — the terms that govern your use of our website and the AI development services we provide."
            />
            <LegalLayout
                eyebrow="Legal"
                title="Terms & Conditions"
                updated="June 9, 2026"
                intro="These Terms & Conditions (“Terms”) govern your access to and use of ezbuildabot.com and the services provided by ezBuildabot, a service of Gadget Guy Media (“we,” “us,” or “our”). By using this website or engaging our services, you agree to these Terms."
            >
                <LegalSection title="1. Acceptance of terms">
                    <p>
                        By accessing or using our website, submitting a form, or engaging us for
                        any project, you confirm that you have read, understood, and agree to be
                        bound by these Terms. If you do not agree, please do not use the site or
                        our services.
                    </p>
                </LegalSection>

                <LegalSection title="2. Our services">
                    <p>
                        ezBuildabot provides custom AI development services, including AI agents,
                        full-stack web applications, and landing pages. The specific scope,
                        deliverables, timeline, and price for any engagement will be defined in a
                        separate written proposal or agreement provided to you after a discovery
                        call. In the event of any conflict, that project-specific agreement takes
                        precedence over these Terms.
                    </p>
                </LegalSection>

                <LegalSection title="3. Quotes, pricing, and payment">
                    <p>
                        Pricing shown on this website (such as starting prices and package
                        figures) is indicative and provided for general guidance. Final pricing is
                        scoped and fixed after a free consultation. Payment terms, deposits, and
                        schedules will be set out in your project agreement. Fees are
                        non-refundable except where expressly stated in that agreement.
                    </p>
                </LegalSection>

                <LegalSection title="4. Client responsibilities">
                    <p>To deliver your project, we may rely on you to:</p>
                    <LegalList
                        items={[
                            "Provide accurate, complete information and timely feedback",
                            "Supply any required access, accounts, content, or third-party credentials",
                            "Ensure you have the rights to any materials you provide to us",
                            "Review and approve deliverables within agreed timeframes",
                        ]}
                    />
                    <p>
                        Delays in providing these may affect timelines and delivery dates.
                    </p>
                </LegalSection>

                <LegalSection title="5. Intellectual property">
                    <p>
                        Upon full payment for an engagement, ownership of the final custom
                        deliverables created specifically for you transfers to you, unless your
                        project agreement states otherwise. We retain ownership of our pre-existing
                        tools, frameworks, methodologies, and any general know-how used to build
                        your project. All content on this website, including text, branding, and
                        design, remains the property of ezBuildabot / Gadget Guy Media.
                    </p>
                </LegalSection>

                <LegalSection title="6. Third-party services">
                    <p>
                        Our deliverables may integrate third-party platforms and APIs (for
                        example, AI model providers, payment processors, or hosting services).
                        Your use of those services is subject to their own terms and pricing, and
                        we are not responsible for their availability, performance, or changes.
                    </p>
                </LegalSection>

                <LegalSection title="7. Acceptable use">
                    <p>
                        You agree not to use our website or services for any unlawful purpose, to
                        infringe the rights of others, to attempt to gain unauthorized access to
                        our systems, or to interfere with the proper functioning of the site.
                    </p>
                </LegalSection>

                <LegalSection title="8. Disclaimers">
                    <p>
                        Our website and services are provided “as is” and “as available” without
                        warranties of any kind, whether express or implied, to the fullest extent
                        permitted by law. While we work hard to deliver high-quality results, we do
                        not warrant that the site or any deliverable will be error-free,
                        uninterrupted, or fit for a particular purpose beyond what is agreed in
                        your project agreement.
                    </p>
                </LegalSection>

                <LegalSection title="9. Limitation of liability">
                    <p>
                        To the maximum extent permitted by law, ezBuildabot and Gadget Guy Media
                        will not be liable for any indirect, incidental, special, or consequential
                        damages, or for any loss of profits or data, arising out of your use of
                        the site or services. Our total liability for any claim relating to a
                        project will not exceed the amount you paid us for that project.
                    </p>
                </LegalSection>

                <LegalSection title="10. Governing law">
                    <p>
                        These Terms are governed by the laws of the State of Tennessee, USA,
                        without regard to its conflict-of-law principles. Any disputes will be
                        subject to the exclusive jurisdiction of the courts located in Tennessee.
                    </p>
                </LegalSection>

                <LegalSection title="11. Changes to these terms">
                    <p>
                        We may update these Terms from time to time. Changes take effect when we
                        post the revised version on this page and update the “Last updated” date.
                        Your continued use of the site after changes are posted constitutes
                        acceptance of the updated Terms.
                    </p>
                </LegalSection>

                <LegalSection title="12. Contact us">
                    <p>
                        Questions about these Terms? Email{" "}
                        <a
                            href="mailto:info@ezbuildabot.com"
                            className="text-[#00f0ff] hover:text-white transition-colors"
                        >
                            info@ezbuildabot.com
                        </a>{" "}
                        or reach out through our{" "}
                        <Link
                            to="/contact"
                            className="text-[#00f0ff] hover:text-white transition-colors"
                        >
                            contact page
                        </Link>
                        .
                    </p>
                </LegalSection>
            </LegalLayout>
        </>
    );
}
